import { ScrollArea } from '@base-ui/react/scroll-area'

import styles from './index.module.scss'

import type { ComponentProps } from 'react'


import { forwardRef } from 'react';
import { tw } from 'tagged-classnames-free';
export interface IScrollAreaClassNames {
  viewport?: string
  content?: string
  scrollbar?: string
  thumb?: string
}

export interface IScrollAreaProps
  extends ComponentProps<typeof ScrollArea.Root> {
  classNames?: IScrollAreaClassNames
  scrollbarVisibility?: 'always' | 'hoverOrScroll' | 'none'
  orientation?: 'vertical' | 'horizontal'
  viewportProps?: ComponentProps<typeof ScrollArea.Viewport>
  /**
   * 禁用滚动容器，渲染为普通 div（保留 className/ref/children 透传）。
   * 适用于移动端不需要独立滚动区域的场景。
   */
  disabled?: boolean
}

const TadScrollArea = forwardRef<HTMLDivElement, IScrollAreaProps>(
  (
    {
      children,
      classNames,
      scrollbarVisibility = 'hoverOrScroll',
      orientation = 'vertical',
      viewportProps,
      disabled,
      ...rest
    },
    ref,
  ) => {
    if (disabled) {
      const { className, ...restProps } = rest
      return (
        <div ref={ref} className={className as string} {...restProps}>
          {children}
        </div>
      )
    }

    const isHoverOrScroll = scrollbarVisibility === 'hoverOrScroll'
    const isHorizontal = orientation === 'horizontal'

    const { className: viewportClassName, ...restViewportProps } =
      viewportProps ?? {}

    // 横向滚动时，鼠标滚轮垂直滚动转为水平滚动
    const handleWheel = isHorizontal
      ? (e: React.WheelEvent<HTMLDivElement>) => {
          if (e.deltaY !== 0 && e.deltaX === 0) {
            e.currentTarget.scrollLeft += e.deltaY
          }
        }
      : undefined

    return (
      <ScrollArea.Root {...rest}>
        <ScrollArea.Viewport
          ref={ref}
          className={tw`${styles.viewport} ${classNames?.viewport} ${viewportClassName}`}
          onWheel={handleWheel}
          {...restViewportProps}
        >
          <ScrollArea.Content
            style={{ minWidth: 'auto' }}
            className={classNames?.content}
          >
            {children}
          </ScrollArea.Content>
        </ScrollArea.Viewport>

        {scrollbarVisibility !== 'none' && (
          <ScrollArea.Scrollbar
            orientation={orientation}
            keepMounted={!isHorizontal}
            className={tw`${isHorizontal ? styles.scrollbarH : styles.scrollbar} ${isHoverOrScroll && styles.isHoverOrScroll} ${classNames?.scrollbar}`}
          >
            <ScrollArea.Thumb
              className={tw`${styles.thumb} ${isHorizontal ? styles.thumbH : styles.thumbV} ${classNames?.thumb}`}
            />
          </ScrollArea.Scrollbar>
        )}
      </ScrollArea.Root>
    )
  },
)

TadScrollArea.displayName = 'TadScrollArea'

export default TadScrollArea
